import { Typography, TypographyProps } from '@mui/material';
import { FC, ReactChild, useEffect, useRef, useState } from 'react';
import TooltipOne from '../TooltipOne/TooltipOne.component';

export interface OverflowTypograpyProps extends TypographyProps {
  children: ReactChild;
}

export const OverflowTypograpy: FC<OverflowTypograpyProps> = ({ children, ...props }) => {
  const ref = useRef<HTMLSpanElement>(null);
  const [tooltipEnabled, setTooltipEnabled] = useState(false);

  useEffect(() => {
    const compareSize = () => {
      if (ref.current) {
        const compare = ref.current.scrollWidth > ref.current.clientWidth;

        setTooltipEnabled(compare);
      }
    };
    compareSize();
    window.addEventListener('resize', compareSize);
    return () => window.removeEventListener('resize', compareSize);
  }, []);

  return (
    <TooltipOne title={children} disableHoverListener={!tooltipEnabled}>
      <Typography ref={ref} noWrap overflow="hidden" textOverflow="ellipsis" {...props}>
        {children}
      </Typography>
    </TooltipOne>
  );
};
